import { SortDirection } from './enums/sortDirection';
export class Sorter {
    constructor(field, direction = SortDirection.Asc) {
        this.field = field;
        this.direction = direction;
    }
    getField() {
        return this.field;
    }
    getDirection() {
        return this.direction;
    }
}
//# sourceMappingURL=sorter.js.map